// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ChartOptionsBuilder from './Izenda.ChartOptionsBuilder';
import vizEngineFactories from 'share/factories/Izenda.VizEngineFactories';
import cfgFactories from 'share/factories/Izenda.ReportPartStyleConfigurationFactories';

@observer
export default class SimpleChart extends Component {
  chart: null;
  constructor() {
    super();
    this.state = {
      chartMsg: ''
    };
  }

  componentWillReceiveProps() {
    this.setState({ chartMsg: null });
  }

  componentDidUpdate() {
    this.renderChart();
  }

  componentDidMount() {
    this.renderChart();
  }

  componentWillUnmount() {
    this.chart && this.chart.destroy && this.chart.destroy();
  }

  render() {
    const style = this.props.style || {};
    return (
      <div ref='chart' className='izenda-chart' style={style}>
        {this.state.chartMsg}
      </div>
    );
  }

  renderChart() {
    // do not draw chart
    if (this.state.chartMsg) {
      const { finishedRender } = this.props;
      if (typeof finishedRender === 'function') {
        finishedRender();
      }

      return;
    }

    const { type: reportPartType, chartType: reportPartStyle } = this.props;

    try {
      // Get configuration of the report part style
      const { visualEngine, visualType, optionsMapping, optionsBuilder } = cfgFactories.getConfiguration(
        reportPartType,
        reportPartStyle
      );

      // Get visualization engine of the report part style. This viz engine was associated with the particular
      // report part style in its configuration.
      const vizEngine = vizEngineFactories.getVisualizationEngine(visualEngine, reportPartStyle);

      // Build the visualization options,aka configuration in order to guide the visualization to render
      const options = this.buildOptions(optionsMapping, visualType, optionsBuilder);

      // Invoke viz engine to execute drawing into chart container
      this.chart = vizEngine.draw(this.refs.chart, visualType, options, this.renderCompleted);
    } catch (e) {
      console && console.error(e.message, e);
      this.setState({ chartMsg: 'Can\'t draw chart' });
    }
  }

  /**
   * Constructs the visualization specific options using configured builder
   * @param {Object} optionsMapping Options mapping
   * @param {string} visualType The visualization spec type, e.g. 'line' in Highchart.
   * @param {Function} optionsBuilder The option builder class
   */
  buildOptions(optionsMapping, visualType, optionsBuilder) {
    const { chartOptions, chartData, seriesOptions, onClickXLabel, onClickYLabel } = this.props;

    const Builder = optionsBuilder || ChartOptionsBuilder;

    const builder = new Builder(visualType, this.refs.chart, chartData, chartOptions, seriesOptions);
    builder.mapOptionValues(optionsMapping);

    onClickXLabel && builder.setOnClickXLabel(e => onClickXLabel(e));
    onClickYLabel && builder.setOnClickYLabel(e => onClickYLabel(e));

    return builder.build();
  }

  renderCompleted = (chart: any) => {
    // Remove clipping after animation had been completed to help IE not stuttering when scrolling with sticky
    if (chart && chart.clipRect && chart.clipRect.clipPath) {
      chart.clipRect.clipPath.destroy();
      chart.clipRect.clipPath = null;
    }

    const { finishedRender, fulfilledData } = this.props;
    if (finishedRender && fulfilledData) {
      finishedRender();
    }
  };
}



// WEBPACK FOOTER //
// ./ui/share/components/charting/Izenda.SimpleChart.js